module.exports = __webpack_public_path__ + "assets/images/amountofPlants-03.f0d51ef1e2a543d00d9324d87cc10e3e.svg";